/**
 * Забытый пароль команды в два шага: POST `auth/password/forgot` шлёт код
 * на телефон (ответ одинаков и для чужого номера), POST
 * `auth/password/reset` ставит новый пароль по коду. После сброса все
 * сессии аккаунта отозваны — входить заново.
 */

import {apiEnabled, http} from '@services/utils';
import {toE164} from '@utils/phone';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

/** devCode — только на dev-гейтвее, в проде всегда null */
export const requestResetCode = async (phone: string): Promise<{devCode: string | null}> => {
  if (!apiEnabled) {
    await sleep(400);
    return {devCode: '123456'};
  }
  const r = await http<{devCode?: string | null}>('auth/password/forgot', {
    method: 'POST',
    body: {phone: toE164(phone)},
    skipCaseConversion: true,
  });
  return {devCode: typeof r.devCode === 'string' ? r.devCode : null};
};

export type ResetPasswordInput = {phone: string; code: string; newPassword: string};

export const resetPassword = async (input: ResetPasswordInput): Promise<void> => {
  if (!apiEnabled) {
    await sleep(400);
    return;
  }
  await http('auth/password/reset', {
    method: 'POST',
    body: {phone: toE164(input.phone), code: input.code.trim(), newPassword: input.newPassword},
    skipCaseConversion: true,
  });
};
